import { html as cookieHtml } from '../../../../doc/legal/cookie_policy.md';
import { LegalPageLayout } from '@/components/layout/LegalPageLayout';

export function CookiePolicyPage() {
  return (
    <LegalPageLayout title="Cookieポリシー" lastUpdated="2025年1月11日">
      <div dangerouslySetInnerHTML={{ __html: cookieHtml }} />
    </LegalPageLayout>
  );
}

export default CookiePolicyPage;
